import React, { Component } from 'react';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory, { Type } from 'react-bootstrap-table2-editor';
import ControlsRenderer from '../../components/custom_controls_renderer'
import { connect } from 'react-redux';
import { updateRisk } from '../../actions/risk'

class PlanIndexTable extends Component {
  constructor(props){
    super(props);
    this.planColumns = [
      {
        dataField: 'step',
        text: 'Step In Process',
        formatter: this.cellFormatter,
        editor: {
          type: Type.TEXTAREA
        },
        headerTitle: true,
        title: true,
        editCellClasses: 'textarea-style',
      },
      {
        dataField: 'hazard',
        text: 'Hazardous Condition',
        formatter: this.cellFormatter,
        editor: {
          type: Type.TEXTAREA
        },
        headerTitle: true,
        title: true,
        editCellClasses: 'textarea-style',
      },
      {
        dataField: 'likelihood',
        text: 'Likelihood',
        formatter: this.cellFormatter,
        editCellClasses: 'textarea-style',
        editor: {
          type: Type.SELECT,
          options: [{
            value: '1 (Rare)',
            label: '1 (Rare)'
          }, {
            value: '2 (Unlikely)',
            label: '2 (Unlikely)'
          }, {
            value: '3 (Possible)',
            label: '3 (Possible)'
          }, {
            value: '4 (Likely)',
            label: '4 (Likely)'
          }, {
            value: '5 (Almost Certain)',
            label: '5 (Almost Certain)'
          }]
        },
        headerStyle: {
          width: '80px'
        },
        headerTitle: (column, colIndex) => 'Likelihood of Hazardous Condition being realized (independent of consequence e.g. likelihood of vehicle collision )',
        title: true
      },
      {
        dataField: 'safety',
        text: 'S', //Safety
        formatter: this.cellFormatter,
        editCellClasses: 'textarea-style',
        editor: {
          type: Type.TEXTAREA
        },
        headerStyle: {
          width: '40px'
        },
        headerTitle: (column, colIndex) => 'Safety',
        title: true
      },
      {
        dataField: 'health',
        text: 'H', //Health
        formatter: this.cellFormatter,
        editCellClasses: 'textarea-style',
        editor: {
          type: Type.TEXTAREA
        },
        headerStyle: {
          width: '40px'
        },
        headerTitle: (column, colIndex) => 'Health',
        title: true
      },
      {
        dataField: 'environmental_impact',
        text: 'E', //'Environment'
        formatter: this.cellFormatter,
        editCellClasses: 'textarea-style',
        editor: {
          type: Type.TEXTAREA
        },
        headerStyle: {
          width: '40px'
        },
        headerTitle: (column, colIndex) => 'Environmental Impact',
        title: true
      },
      {
        dataField: 'business_interuption',
        text: 'BI', //'Business Interruption'
        formatter: this.cellFormatter,
        editCellClasses: 'textarea-style',
        editor: {
          type: Type.TEXTAREA
        },
        headerStyle: {
          width: '40px'
        },
        headerTitle: (column, colIndex) => 'Business Interruption Material Damage',
        title: true
      },
      {
        dataField: 'legal_and_regulatory',
        text: 'L', //'Legal'
        formatter: this.cellFormatter,
        editCellClasses: 'textarea-style',
        editor: {
          type: Type.TEXTAREA
        },
        headerStyle: {
          width: '40px'
        },
        headerTitle: (column, colIndex) => 'Legal & Regulatory',
        title: true
      },
      {
        dataField: 'social_community',
        text: 'R', //'Reputation'
        formatter: this.cellFormatter,
        editCellClasses: 'textarea-style',
        editor: {
          type: Type.TEXTAREA
        },
        headerStyle: {
          width: '40px'
        },
        headerTitle: (column, colIndex) => 'Social Community / Reputation Impact',
        title: true
       },
      {
        dataField: 'highest_rating',
        text: 'Highest Risk Rating',  //'Highest Risk Rating'
        formatter: this.cellFormatter,
        editCellClasses: 'textarea-style',
        editor: {
          type: Type.TEXTAREA
        },
        headerStyle: {
          width: '85px'
        },
        headerTitle: (column, colIndex) => 'Highest Risk Rating',
        title: true,
        editable: false
      },
    ];
  }

  shouldComponentUpdate(nextProps, nextState){
    if (nextProps.shouldNotRender){
      return false;
    }
    else {
      return true;
    }
  }

  cellFormatter(cell, row) {
    return (
     <div className='cell-style'>
      { cell }
     </div>
    );
  }

  controlsCellFormatter(cell, row, planId) {
    return <ControlsRenderer value={cell} planId={planId} riskId={row.id}/>
  }

  updateRisk(oldValue, newValue, row, column, object){
    if (oldValue === newValue) {
      return;
    }

    if (column.dataField === 'likelihood' && (newValue==='' || newValue===null)){
      row[column.dataField] = oldValue
      return;
    }
    var likelihood = row.likelihood.split('(')
    let metadata = {
      activity: row.activity,
      consequences_description: row.consequences_description,
      linked_to_hazard: row.linked_to_hazard,
      highest_rating: row.highest_rating,
      step_and_hazard: row.step + ': ' + row.hazard,
      consequences: [
        {
          key: 'safety',
          value: row.safety
        },
        {
          key: 'health',
          value: row.health
        },
        {
          key: 'environmental_impact',
          value: row.environmental_impact
        },
        {
          key: 'business_interuption',
          value: row.business_interuption
        },
        {
          key: 'legal_and_regulatory',
          value: row.legal_and_regulatory
        },
        {
          key: 'social_community',
          value: row.social_community
        },
      ],
      likelihood: {
        type: likelihood[1].replace(')', ''),
        value: likelihood[0].replace(' ', '')
      }
    }
    let risk = {
      id: row.id,
      metadata: JSON.stringify(metadata)
    };
    this.props.updateRisk(this.props.planId, risk, newValue, row);
  }

  handleRiskColumns(oldValue, newValue, row, column, object){
    //execute validations here
  }

  render() {
    const { risks } = this.props;

    return (
      <BootstrapTable
        tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }}
        keyField="id"
        data={ risks }
        columns={ this.planColumns }
        cellEdit={ cellEditFactory({
            mode: 'click',
            blurToSave: true,
            beforeSaveCell: (oldValue, newValue, row, column, object) => this.handleRiskColumns(oldValue, newValue, row, column, this),
            afterSaveCell: (oldValue, newValue, row, column, object) => this.updateRisk(oldValue, newValue, row, column, this)
          })
        }
        striped
        hover
        condensed
        noDataIndication={<span className="no-data-indication"><i className="file alternate icon"></i>No Risks have been selected.</span>}
      />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    updateSuccess: state.risk.updateSuccess,
    pending: state.risk.pending,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateRisk: (plan_id, risk, cellValue, row) => {
      dispatch(updateRisk(plan_id, risk, cellValue, row))
    },
  }
}

let PlanIndexTableView = connect(mapStateToProps, mapDispatchToProps)(PlanIndexTable)
export default PlanIndexTableView;



// WEBPACK FOOTER //
// ./src/views/plan_tables/index_table.js